module.exports = __webpack_public_path__ + "static/sobre_empaques-3e11466ff3ed7f2bafd5fcfe0304317c.png";